import { BrandedContent } from 'homepage/components/brandView/BrandedContent';
import { BrandSpaceContent } from 'homepage/components/brandView/BrandSpaceContent';
import { SECTION_TYPES } from 'homepage/enums/contentConstants';

interface IVerticalScrollTabProps {
  isMobile: boolean;
  draftId?: number;
  draftUuid?: string;
  drawerName: string;
  firstVideo: boolean;
  heroes: any;
  setIsFirstVideo: (boolean) => void;
}

export const VerticalScrollTab = ({
  draftId = null,
  draftUuid = null,
  drawerName = 'brand',
  firstVideo,
  isMobile,
  heroes,
  setIsFirstVideo,
}: IVerticalScrollTabProps) => {
  const topLevelArticle = heroes?.[0]?.articles?.[isMobile ? 1 : 0];

  const moduleTrackingData = {
    collection_id: null,
    collection_slug: null,
    event_context: 'brand_feed',
    draft_id: draftUuid || String(draftId),
    section_id: topLevelArticle?.uuid || String(topLevelArticle?.id),
    section_position: 0,
    section_type: SECTION_TYPES.SPACE_ARTICLE_SECTION,
    section_name: topLevelArticle?.subject,
  };

  return (
    <>
      {heroes?.length === 1 &&
        heroes?.map((item, index) =>
          item?.type === SECTION_TYPES.SPACE_ARTICLE_SECTION ? (
            <BrandSpaceContent
              draftId={draftId}
              draftUuid={draftUuid}
              drawerName={drawerName}
              key={item?.uuid || item?.id}
              moduleTrackingData={{ ...moduleTrackingData, segment_id: item?.segmentId }}
              section={item}
              sectionIndex={0}
              isSingleSpaceBrandPage
            />
          ) : (
            <BrandedContent
              key={item?.uuid || item?.id}
              drawerName={drawerName}
              {...item}
              index={index}
              firstVideo={firstVideo}
              setFirstVideo={setIsFirstVideo}
            />
          ),
        )}
    </>
  );
};
